import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IMyKnownError } from 'interfaces/requests';
import { exemptionClear } from 'modules/exemption';
import { FORM_MODE } from '../../shared/enums';

const initialState: FORM_MODE = FORM_MODE.list as FORM_MODE;

export const setExemptionModeAction = createAsyncThunk<
  FORM_MODE,
  FORM_MODE,
  { rejectValue: IMyKnownError }
>('exemptionNavigationMode/set', async (payload, { dispatch }) => {
  if (payload === FORM_MODE.create) {
    dispatch(exemptionClear());
  }

  return payload;
});

const exemptionNavigationModeSlice = createSlice({
  name: 'exemptionNavigationMode',
  initialState,
  reducers: {
    resetExemptionModeAction(state) {
      state = initialState;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setExemptionModeAction.fulfilled, (state, { payload }) => {
      state = payload;
      return state;
    });
  },
});

const { reducer, actions } = exemptionNavigationModeSlice;
export const { resetExemptionModeAction } = actions;
export default reducer;
